import * as React from 'react';

import { FormControlLabel, Radio, RadioGroup } from '@emburse/ui-core';

import { ICardsGatewayIssuingModalValues } from '@Actions/cardsGatewayIssuingModalActions';

import { isPhysicalCardIssuingEnabled } from '@Shared/helpers/validators';
import { AccountCapabilities, CardType } from '@Shared/interfaces/CardsGatewayInterfaces';
import { IUserProfileModel } from '@Shared/models';

const VIRTUAL_RADIO_ITEMS = [
  {
    label: 'Issue Virtual Card',
    value: CardType.Ghost
  },
  {
    label: 'Mail Plastic Card',
    value: CardType.Physical
  }
];

interface ICardTypeFormProps {
  linkedAccountId?: string;
  capabilities: AccountCapabilities;
  cardType: string;
  userProfile: IUserProfileModel;
  onChange: (update: Partial<ICardsGatewayIssuingModalValues>) => void;
}

export const CardTypeFormBase: React.FC<ICardTypeFormProps> = ({ linkedAccountId, capabilities, cardType, onChange, userProfile }) => {
  // TODO: Move these a level up
  const editMode = Boolean(linkedAccountId);
  const virtualCardForm = Boolean(capabilities.issuing?.virtual);
  const company = window.ORG;

  /**
   * Does not display if editing a card.
   *
   * Does not display if issuing virtual cards.
   *
   * If possible to issue both types of real cards, render the radio.
   *
   * If only possible to issue physical cards (or physical radio option is chosen), render shipping address form.
   */
  // cannot switch card type when updating
  if (editMode) {
    return null;
  }

  if (cardType === CardType.Virtual) {
    return null;
  }

  let canSelectCardType;
  if (virtualCardForm) {
    // If virtual card issuing is available, you must issue virtual cards only
    canSelectCardType = false;
  } else {
    // Otherwise, you can select type if ghost issuing and physical issuing are both enabled
    const canIssuePhysicalCards = isPhysicalCardIssuingEnabled(company, userProfile);

    canSelectCardType = capabilities.issuing.physical && canIssuePhysicalCards && capabilities.issuing.ghost;
  }

  return (
    <>
      {canSelectCardType && (
        <RadioGroup
          name="ghost"
          value={cardType}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange({ cardType: event.target.value as CardType })}
          style={{ display: 'inline-block', marginBottom: 16 }}
        >
          {VIRTUAL_RADIO_ITEMS.map((radioItem) => (
            <FormControlLabel key={radioItem.value} value={radioItem.value} control={<Radio />} label={radioItem.label} />
          ))}
        </RadioGroup>
      )}
    </>
  );
};

export const CardTypeForm = React.memo(CardTypeFormBase);
